export const isValidMaxFileWeight = ({ maxFileWeight, fileWeight }) => {
	if (maxFileWeight && fileWeight > maxFileWeight) {
		return false;
	}
	return true;
};
